import * as structural from './structural';
import * as emotion from './emotion';
import * as perception from './perception';
import * as play from './Play';
import * as listen from './Listen';
import * as display from './Display';
import * as slim from './SLIM';

/**
 * @description Namespace for the v2 RCP protocol.
 * </br> See [Phoenix RCP](https://github.jibo.com/phoenix/jibo-command-protocol) for all `JIBO` docs.
 * @namespace Requester.v2
 * @intdocs
 */

export {
    play,
    listen,
    display,
    slim,
    perception,
    emotion,
    structural
};
